export default {
    namespaced: true,
    state: () => ({
        tableOptions:
        {
            page: 1,
            itemsPerPage : 25,
            sortBy : [ "fullName" ],
            sortDesc : [ false ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : true
        },

        loadWhenMounted: false,
        searchType: 0,

        filterFio: {
            surname: "",
            name: "",
            patronymic: "",
            birthDateFrom: null,
            region: null
        },
        filterIin: {
            iin: "",
            region: null
        },
        selectedRegion: null,
        selectedCity: null,
        selectedStreet: null,
        selectedHouse: null
    }),
    mutations: {
        SET_TABLE_OPTION(state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE(state, payload) {
            state.tableOptions.page = payload;
        },
        SET_LOAD_WHEN_MOUNTED(state, payload) {
            state.loadWhenMounted = payload;
        },
        SET_SEARCH_TYPE(state, payload) {
            state.searchType = payload;
        },
        SET_FILTER_FIO(state, payload) {
            state.filterFio = payload;
        },
        SET_FILTER_IIN(state, payload) {
            state.filterIin = payload;
        },
        SET_SELECTED_REGION(state, payload) {
            state.selectedRegion = payload;
        },
        SET_SELECTED_CITY(state, payload) {
            state.selectedCity = payload;
        },
        SET_SELECTED_STREET(state, payload) {
            state.selectedStreet = payload;
        },
        SET_SELECTED_HOUSE(state, payload) {
            state.selectedHouse = payload;
        }
    },
    getters: {
        getTableOptions: (s) => s.tableOptions,
        isLoadWhenMounted: (s) => s.loadWhenMounted,
        getSearchType: (s) => s.searchType,
        getFilterFio: (s) => s.filterFio,
        getFilterIin: (s) => s.filterIin,
        getSelectedRegion: (s) => s.selectedRegion,
        getSelectedCity: (s) => s.selectedCity,
        getSelectedStreet: (s) => s.selectedStreet,
        getSelectedHouse: (s) => s.selectedHouse
    }
}